<h2 class="text-xl font-semibold text-center">Rate Our Service</h2>
<div>
  <p>
    Our team is committed to improving our service to best support you through
    this challenging time.
  </p>
  <p>
    Any suggestions you can provide, will assist us in improving the journey for
    others. We value any feedback you provide.
  </p>
</div>
<form [formGroup]="formFeedback" (ngSubmit)="submit()">
  <div class="label">How do you rate the booking team?</div>
  <div class="star-row">
    @for (star of stars; track $index) {
      <button
        type="button"
        (click)="setTeamRating($index + 1)"
        [class.active]="$index < formFeedback.controls.teamRating.value">
        ★
      </button>
    }
  </div>

  <div class="label">How do you rate the accommodation?</div>
  <div class="star-row">
    @for (star of stars; track $index) {
      <button
        type="button"
        (click)="setBookingRating($index + 1)"
        [class.active]="$index < formFeedback.controls.bookingRating.value">
        ★
      </button>
    }
  </div>

  <div>
    <div class="label">Add your comments</div>
    <textarea formControlName="comment" name="comment" rows="4"></textarea>
  </div>
  <div class="submit-btn">
    <button type="submit" [disabled]="loading()" class="hover:bg-blue-700">
      {{ loading() ? 'Submitting...' : 'Submit Feedback' }}
    </button>
  </div>
</form>
<div class="phone-message">
  <p>
    If you have any questions, please don't hesitate to call us on
    <a href="tel:1800994412"><b>1800 994 412</b></a
    >.
  </p>
</div>
@if (feedbackSent()) {
  <app-confirmed-feedback />
}
